import React from "react";
import Home from "./Home";
import Linker from "../Navigation Components/Linker";

const FormalisationsEnonces = () => {
  return (
    <div>
      <h2>FormalisationsEnonces</h2>
      <Linker link="/" path="/" components={Home} name="Retour au menu" />
    </div>
  );
};

export default FormalisationsEnonces;



// WEBPACK FOOTER //
// ./src/components/Pages/FormalisationEnonces.js